import { Css, useSnackbar } from "@homebound/beam";
import { DeleteConfirmationModal } from "src/routes/components/DeleteConfirmationModal";
import { SaveTliResult } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { count } from "src/utils";

type DeleteItemsConfirmationModalProps = {
  itemIdsToDelete: string[];
  /** Deactivates the lines, i.e. `useDeleteTakeoffLines`, which also rejects any AI proposals pending for them */
  deleteLines: (tliIds: string[]) => SaveTliResult;
  /** Called once the lines are deleted, e.g. to close the side panel that showed them */
  onDeleted?: VoidFunction;
};

export function DeleteItemsConfirmationModal(props: DeleteItemsConfirmationModalProps) {
  const { itemIdsToDelete, deleteLines, onDeleted } = props;
  const { triggerNotice } = useSnackbar();

  return (
    <DeleteConfirmationModal
      entityType="Item"
      confirmationMessage={
        <div>
          <p css={Css.sm.mb2.$}>{count(itemIdsToDelete, "item")} selected</p>
          <p>Are you sure you want to delete these items? This action cannot be undone.</p>
        </div>
      }
      onConfirmDelete={async () => {
        const { data } = await deleteLines(itemIdsToDelete);
        if (data) {
          const deleteItems = data.saveTakeoffLineItems.deleted.length + data.saveTakeoffLineItems.removed.length;
          triggerNotice({
            message: `${deleteItems === 1 ? "Item has" : `${deleteItems} items have`} been deleted`,
            icon: "success",
          });
          onDeleted?.();
        }
      }}
    />
  );
}
